(function () {
  function todayKey() {
    const d = new Date();
    return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
  }

  function hashString(str) {
    let h = 2166136261;
    for (let i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
    }
    return Math.abs(h);
  }

  function getNumberForProduct(productId, min, max) {
    const key = "ra_sp_" + productId + "_" + todayKey();
    const stored = localStorage.getItem(key);
    if (stored) return parseInt(stored, 10);

    // Stable pseudo-random: productId + date
    const seed = hashString(productId + "_" + todayKey());
    const range = Math.max(1, (max - min + 1));
    const val = min + (seed % range);

    localStorage.setItem(key, String(val));
    return val;
  }

  function init() {
    const nodes = document.querySelectorAll("[data-ra-social-proof]");
    if (!nodes.length) return;

    nodes.forEach((el) => {
      const productId = el.getAttribute("data-ra-product-id");
      const min = parseInt(el.getAttribute("data-ra-min") || "4", 10);
      const max = parseInt(el.getAttribute("data-ra-max") || "28", 10);

      if (!productId) return;

      const n = getNumberForProduct(productId, min, max);
      const textEl = el.querySelector("[data-ra-social-proof-text]");
      if (textEl) textEl.textContent = String(n);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // For sections that re-render (Shopify theme editor)
  document.addEventListener("shopify:section:load", init);
})();